import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, ButtonGroup, Col, Label, Row } from 'reactstrap';
import { AvField, AvForm, AvGroup } from 'availity-reactstrap-validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';
import { hasAnyPermission } from 'app/shared/auth/permissions';
import { MmamaEntityType } from 'app/shared/model/enumerations/mmama-entity-type.model';
import { getMasterEntity, updateMasterEntity, reset } from './mmama-entity.reducer';

export interface IMmamaEntityMasterUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const MmamaEntityMasterUpdate = (props: IMmamaEntityMasterUpdateProps) => {
  const { masterEntity, loading, updating, updateSuccess, hasUpdateAccess } = props;
  const [mandatory, setMandatory] = useState(false);

  const handleClose = () => {
    props.history.goBack();
  };

  useEffect(() => {
    props.reset();
    props.getMasterEntity(props.match.params.id);
  }, []);

  useEffect(() => {
    setMandatory(!!masterEntity.required);
  }, [masterEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      props.updateMasterEntity({
        ...masterEntity,
        ...values,
        required: mandatory
      });
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="mmamaEntityMaster.edit">Edit Master Entity</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading || !masterEntity.id ? (
            <p>loading...</p>
          ) : (
            <AvForm model={masterEntity} onSubmit={saveEntity}>
              <br />
              <Row className="justify-content-left">
                <Col md="6">
                  <AvGroup>
                    <Label for="mmama-entity-master-enumName">Enum Name</Label>
                    <AvField id="mmama-entity-master-enumName" type="text" name="enumName" readOnly />
                  </AvGroup>
                </Col>
                <Col md="6">
                  <AvGroup>
                    <Label for="mmama-entity-master-type">Type</Label>
                    <AvField id="mmama-entity-master-type" type="text" name="type" readOnly />
                  </AvGroup>
                </Col>
                <Col md="6">
                  <AvGroup>
                    <Label for="mmama-entity-master-entityName">English Name</Label>
                    <AvField
                      id="mmama-entity-master-entityName"
                      type="text"
                      name="entityName"
                      disabled={!hasUpdateAccess}
                      validate={{ required: { value: true, errorMessage: 'This field is required' } }}
                    />
                  </AvGroup>
                </Col>
                <Col md="6">
                  <AvGroup>
                    <Label for="mmama-entity-master-stEntityName">Local Language Name</Label>
                    <AvField
                      id="mmama-entity-master-stEntityName"
                      type="text"
                      name="stEntityName"
                      disabled={!hasUpdateAccess}
                      validate={{ required: { value: true, errorMessage: 'This field is required' } }}
                    />
                  </AvGroup>
                </Col>
                {masterEntity.type === MmamaEntityType.DROPDOWN && (
                  <Col md="12" className="mt-3">
                    <AvGroup>
                      <Label id="required">Is Required</Label>
                      <ButtonGroup style={{ marginLeft: '30px' }}>
                        <Button color={mandatory ? 'primary' : 'secondary'} disabled={!hasUpdateAccess} onClick={() => setMandatory(true)}>
                          Yes
                        </Button>
                        <Button color={!mandatory ? 'primary' : 'secondary'} disabled={!hasUpdateAccess} onClick={() => setMandatory(false)}>
                          No
                        </Button>
                      </ButtonGroup>
                    </AvGroup>
                  </Col>
                )}
              </Row>
              <br />
              <Button tag={Link} id="cancel-save" onClick={handleClose} replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={!hasUpdateAccess || updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  masterEntity: storeState.mmamaEntity.masterEntity,
  loading: storeState.mmamaEntity.loading,
  updating: storeState.mmamaEntity.updating,
  updateSuccess: storeState.mmamaEntity.updateSuccess,
  hasUpdateAccess: hasAnyPermission(storeState.authentication.permissions, ['ADMIN', 'ENTITIES_MODIFY'])
});

const mapDispatchToProps = {
  getMasterEntity,
  updateMasterEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MmamaEntityMasterUpdate);
